import { FelaCSS, FelaCSSWithCustomSelectors, alpha, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  paddingWrapperUpper: FelaCSS;
  paddingWrapperLower: FelaCSS;
  articleContainer: FelaCSSWithCustomSelectors;
  articleContainerWrap: FelaCSS;
  loadingWrap: FelaCSS;
  titleSubtitleWrap: FelaCSS;
  title: FelaCSS;
  subtitle: FelaCSS;
  infoWrap: FelaCSS;
  timeInfo: FelaCSS;
  tag: FelaCSS;
  link: FelaCSS;
  tagContainer: FelaCSS;
  img: FelaCSS;
  imgContainer: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    maxWidthMobile: {
      paddingHorizontal: 0,
    },
    desktopDesign: {
      alignItems: 'center',
    },
  },

  paddingWrapperUpper: {
    alignSelf: 'flex-start',
    maxWidthMobile: {
      paddingHorizontal: 6,
    },
  },

  paddingWrapperLower: {
    maxWidthMobile: {
      paddingHorizontal: 6,
    },
  },

  articleContainer: {
    fontDefault: 16,
    lineHeight: '1.875em',
    wordSpacing: '0.0233em',
    marginBottom: 16,

    maxWidthMobile: {
      overflow: 'hidden', // osx horizontal bounce
    },

    desktopDesign: {
      width: '60%',
      marginRight: '20px',
    },

    '& a:not([data-aura-button])': {
      fontDefaultSemiBold: 'inherit',
      color: colors.blueCrush,
    },

    '& ol': {
      display: 'block',
      marginTop: 0,
      paddingLeft: 10,
      marginBottom: 8,

      '& li': {
        listStyleType: 'decimal',
      },
    },

    '& ul': {
      listStyleType: 'disc',
      display: 'block',
      paddingLeft: 10,
      marginBottom: 8,
    },

    '& li': {
      listStyleType: 'disc',
    },

    '& h1': {
      textAlign: 'center',
    },

    '& h2': {
      fontDefaultSemiBold: 30,

      maxWidthMobile: {
        marginTop: 2,
        marginBottom: 2,
        fontDefaultSemiBold: 25,
      },

      '& a': {
        fontDefault: 'inherit',
      },
    },

    '& h3': {
      marginTop: 6,
      marginBottom: 6,
      fontDefaultSemiBold: 22,

      maxWidthMobile: {
        marginTop: 4,
        marginBottom: 4,
        fontDefaultSemiBold: 18,
      },

      '& a': {
        fontDefault: 'inherit',
      },
    },

    '& p': {
      marginBottom: 8,
    },

    '& figure': {
      marginBottom: 8,
      maxWidth: '100%',
      width: '100%',

      '& img': {
        width: '100%',
      },

      '& figcaption': {
        marginTop: 3,
        fontDefaultSemiBold: 14,
        lineHeight: '1.42em',
        color: colors.space40,

        '& a': {
          color: colors.space40,
        },
      },
    },

    '& table:not(.bb-table-wp)': {
      border: `1px solid ${alpha(colors.black, 10)}`,
      borderWidth: '1px 0 0 1px',
      borderCollapse: 'separate',
      borderSpacing: 0,
      fontDefault: 14,
      lineHeight: '1.28em',
      marginBottom: 5,

      '& td': {
        border: `1px solid ${alpha(colors.black, 10)}`,
        borderWidth: '0 1px 1px 0',
        fontDefault: 14,
        padding: 2,
        verticalAlign: 'baseline',
      },
    },

    '& img': {
      display: 'block',
      maxWidth: '100%',
      height: 'auto',
      marginBottom: 8,
    },

    '& b, & strong': {
      fontDefaultSemiBold: 'inherit',
    },

    '& .fve-video-wrapper': {
      position: 'relative',
      overflow: 'hidden',
      height: 0,
      backgroundColor: 'transparent',
      paddingBottom: '56.25%',
      marginTop: '0.5em',
      marginBottom: '0.5em',

      '& iframe, object, embed': {
        position: 'absolute',
        display: 'block',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
      },

      '& .hyperlink-image': {
        display: 'none',
      },
    },

    '& .aligncenter': {
      margin: '0 auto',
      display: 'block',
    },
  },

  articleContainerWrap: {
    maxWidth: 1250,
    flexDirection: 'row',
    alignContent: 'stretch',
    justifyContent: 'space-between',
    gap: 20,
    marginTop: '17px',
    paddingHorizontal: 10,

    maxWidthMobile: {
      marginTop: 6,
      paddingHorizontal: 0,
    },
  },

  loadingWrap: {
    margin: '40px auto 0',
  },

  titleSubtitleWrap: {
    maxWidthTabletSm: {
      paddingHorizontal: 0,
    },
  },

  title: {
    marginTop: '0',
    marginBottom: '0',
    fontPlayfair: 40,
    textAlign: 'left',
    lineHeight: '120%',
    paddingBottom: 1,

    maxWidthMobile: {
      textAlign: 'left',
      paddingVertical: 4,
      paddingHorizontal: 0,
      fontPlayfair: 28,
      lineHeight: '120%',
    },
  },

  subtitle: {
    marginTop: 4,
    marginBottom: 0,
    fontDefault: 20,
    textAlign: 'left',
    lineHeight: '150%',

    maxWidthMobile: {
      fontDefault: 18,
    },
  },
  infoWrap: {
    flexDirection: 'row',
    gap: '20px',
    paddingHorizontal: 12,
    paddingBottom: '10px',
  },
  timeInfo: {
    fontDefault: 12,
    color: colors.space,
  },
  tagContainer: {
    flexDirection: 'row',
    gap: 4,
    flexWrap: 'wrap',
  },
  tag: {
    borderRadius: 100,
    backgroundColor: colors.indigoCrush04,
    fontDefault: 14,
    height: '35px',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,

    maxWidthMobile: {
      fontDefault: 14,
      height: '33px',
    },
  },
  img: {
    marginBottom: '10px',
    width: '100%',
    maxHeight: 840,
    borderRadius: 16,
    maxWidthMobile: {
      maxHeight: 250,
      borderRadius: 0,
    },
  },
  imgContainer: {
    paddingHorizontal: 8,
    width: '100%',
    alignItems: 'center',
  },
  link: {
    ':hover': {
      textDecoration: 'none',
      color: colors.space,
      backgroundColor: colors.indigoCrush10,
    },
  },
});

export default styles;
